import React, { FC } from 'react';
import Icon from 'src/common/components/IconDS22';
import s from './EditButton.module.scss';

type Props = {
  openModal: () => void;
};

const EditButton: FC<Props> = ({ openModal }) => (
  <button
    className={s.root}
    onClick={openModal}
    type="button"
    data-test="edit-button"
  >
    <Icon
      id="note"
      size="m"
      className={s.icon}
    />
  </button>
);
export default EditButton;
